import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Drawer from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/Drawer';
import DrawerHeader from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/DrawerHeader';
import Tabs from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tabs';
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close';

import { NavTab } from '../types';

import TabLink from './TabLink';

type MobileNavMenuProps = {
  open: boolean;
  activeTab?: number | boolean;
  tabs?: NavTab[];
  onClose: () => void;
  onChange?: (event: React.ChangeEvent<unknown>, tabIndex: number) => void;
};

const MobileNavMenu = ({
  open,
  activeTab,
  tabs = [],
  onClose = () => undefined,
  onChange = () => undefined,
}: MobileNavMenuProps) => {
  return (
    <Drawer version="v2" data-testid="MobileNavMenu-root" open={open} onClose={onClose}>
      <DrawerHeader>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DrawerHeader>
      <Tabs version="v2" value={activeTab} orientation="vertical" width="100%" tabSize="med" onChange={onChange}>
        {tabs.map(({ label, path, badgeValue: badgeCount }) => (
          <TabLink
            key={label}
            href={path}
            version="v2"
            label={<Typography variant="h3">{label}</Typography>}
            /* eslint-disable @typescript-eslint/ban-ts-comment */
            /* @ts-ignore */
            secondary={<Badge color="info" badgeContent={badgeCount} version="v2" />}
          />
        ))}
      </Tabs>
    </Drawer>
  );
};

export default MobileNavMenu;
